import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/led/setting/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/led/setting/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/led/setting/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/led/setting/save', params, options);

export const update = (params, options) =>
  request.post('/api/park/led/setting/update', params, options);
